<template>
  <!-- NOTIFICATIONS -->
  <div>
    <vs-dropdown :key="dropdownKey" v-if="anyDailyNotification" vs-custom-content vs-trigger-click :class="actionElementCss" class="text-black app-notifications" @click="resetJumping">

      <div class="flex flex-col items-center mt-1 sm:mr-6 mr-2" >

       <div class="select-none flex text-xl" >
          <div  class="flex items-center content-end font-bold mr-2"  :class="{'animate-pulse': animateBadge, 'animate-bounce': animateBadgeHard}">
            <feather-icon icon="CompassIcon" svgClasses="h-6 w-6" class="font-bold track-daily-notification-open mr-2" :badge="unreadNotifications.length" />

            <span>today's plan</span>
          </div>

          <span v-if="!$store.getters.isMobile" class="mr-2 text-dark">for {{$store.getters.today | weekDay}}, {{$store.getters.today | date}}</span>
       </div>
         <!-- <vs-progress :percent="progressPercent" color="primary" class="mx-6"></vs-progress> -->
      </div>

      <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

        <div class="notification-top text-center p-5 bg-primary text-white">

          <!-- <h3 class="text-white">daily suggestions</h3> -->
          <p class="text-2xl text-white font-bold flex items-center justify-center">
            <!-- <feather-icon icon="CompassIcon" svgClasses="h-6 w-6" class="font-bold mr-1" /> -->
          today's plan

          <!-- <span class="text-sm ml-1"> (4)</span> -->
        </p>
        </div>

        <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
          <ul class="bordered-items">

            <Notification :class="trackClass(notification)" v-for="notification in notifications" :key="notification.id" :notification="notification" @dropdownClose="dropdownClose" @showPopup="showPopup"/>

          </ul>
        </component>

        <div class="
          checkout-footer
          fixed
          bottom-0
          rounded-b-lg
          text-primary
          w-full
          p-2
          text-center
          border
          border-b-0
          border-l-0
          border-r-0
          border-solid
          d-theme-border-grey-light
          bg-white
          ">

          <span v-if="anyUnread" class="cursor-pointer font-semibold" @click="markAllAsRead">mark all as done</span>

          <div v-else class="justify-center flex items-center text-sm">more suggestions coming tomorrow<feather-icon  icon="CheckIcon" class="w-3 ml-1"/></div>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>

    <GeneralPopup :showPopup="popupActive" :componentName="componentName" @popupHidden="popupActive=false" :componentData="componentData" />
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Notification from './Notification'
import id from '@/helpers/id'

export default {
  components: {
    VuePerfectScrollbar,
    Notification
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      dropdownKey: `notificationsDropdown_${id()}`,
      animateBadge: false,
      animateBadgeHard: false,
      popupActive: false,
      componentName: null,
      componentData: {}
    }
  },
  watch: {
    '$store.getters.todayKey': {
      immediate: false,
      handler (todayKey) {
        this.setupJumping()
      }
    },
  },
  computed: {
    progressPercent () {
      if (this.readNotifications.length == 0) {
        return 5
      } else {
        return ((100 * this.readNotifications.length) / this.notifications.length)
      }

    },
    jumpingCompass () {
      return this.animateBadge
      // return !this.$store.getters.notificationClicked
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    unreadNotifications () { return _.sortBy(this.$store.getters.unreadNotifications, 'index') },
    readNotifications () { return _.difference(this.notifications, this.unreadNotifications) },
    notifications () { return _.sortBy(this.$store.getters.todayNotifications, 'index') },
    sortedNotifications () { return _.concat(this.unreadNotifications, this.readNotifications) },
    anyDailyNotification () { return this.notifications.length > 0 },
    anyUnread () { return this.unreadNotifications.length > 0 },
  },
  mounted () {
    // this.resetJumping()
    this.setupJumping()
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      this.dropdownClose()
    })
  },
  methods: {
    setupJumping () {
      setTimeout(() => {
        if (this.anyUnread) {
          this.animateBadge = true
        }
      }, 1000 * 60 * 1)

      setTimeout(() => {
        if (this.anyUnread) {
          this.animateBadgeHard = true
        }
      }, 1000 * 60 * 3)
    },
    resetJumping () {
      if (!this.$store.getters.userAdditionalInfo.notificationClicked) {
        this.$store.dispatch('ADDITIONAL_USER_INFO', { notificationClicked: true })
      }

      this.animateBadge = false
      this.animateBadgeHard = false
    },
    trackClass (notification) {
      return `track-notification-${notification.actionName}`
    },
    showPopup (componentName, componentData = null) {
      this.componentName = componentName
      this.popupActive = true
      this.componentData = componentData
    },
    dropdownClose () {
      this.dropdownKey = `notificationsDropdown_${id()}`
    },
    markAllAsRead () {
      _.each(this.unreadNotifications, (notification) =>
        this.$store.dispatch('UPDATE_NOTIFICATION', { notification, updateFields: { read: true, readAt: new Date() } })
        )
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  }
}

</script>
<style land="scss">

  .vs-dropdown--menu--after {
    display: none;
  }

</style>
